import { useMemo, useState } from 'react';
import { message } from 'antd';
import { useMutation } from '@apollo/client';
import { SEARCH_INDEX_DELAY } from '../../consts';
import DELETE_LEARNING_OBJECT_MUTATION from '../mutations/DELETE_LEARNING_OBJECT_MUTATION';
  
const useDeleteLearningObject = () => {
    const [ isDeleting, setIsDeleting ] = useState( false );
    const [ deleteMutation ] = useMutation( DELETE_LEARNING_OBJECT_MUTATION );

    const handleLearningObject = async ( id, onFinishCallback ) => {
        setIsDeleting( true );
        
        try {
            await deleteMutation( { variables: { objectID: id } } );

            setTimeout( () => {
                if ( onFinishCallback ) { onFinishCallback(); }
                setIsDeleting( false );
            }, SEARCH_INDEX_DELAY );
        } catch ( e ) { 
            console.error( e ); 
            message.error( 'Error deleting Learning Object!' );
            setIsDeleting( false );
        }
    };

    return useMemo( () => {
        return {
            isDeleting,
            deleteLearningObject: handleLearningObject
        };
    }, [ isDeleting ] );
};

export default useDeleteLearningObject;
